
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { AuthService } from '../../../Services/auth.service';
import { ApiService } from '../../../Services/api.service';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { AssociatedProductsComponent } from '../associated-products/associated-products.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';


@Component({
  selector: 'app-master-catalog-child-accordion',
  standalone: true,
  imports: [NzIconModule, FormsModule, NzCollapseModule, NzSelectModule, CommonModule, NzButtonModule, NzTagModule, DragDropModule,
    NzModalModule, NzDropDownModule, NzMenuModule, NzToolTipModule, NzDrawerModule, ConfirmPopupComponent, NzModalModule, NzBadgeModule,
    AssociatedProductsComponent, NzSwitchModule],
  templateUrl: './master-catalog-child-accordion.component.html',
  styleUrl: './master-catalog-child-accordion.component.scss'
})
export class MasterCatalogChildAccordionComponent implements OnChanges {
  @Input() catalogs: any = [];
  @Input() drawerView: boolean = false;
  @Input() applyStyleAction: boolean = false;
  showModal: boolean = false;
  modalWidth: string = '520px';
  isAllExpanded: boolean = false;
  showMovePopup: boolean = false;
  modaltitle: any;
  selectedCatalogId: any = "";
  selectedVersion: any = "";
  @Output() emitSeqId = new EventEmitter<string>();
  @Output() emitAction = new EventEmitter<any>();
  modalButton: string = '';
  modalMessage: string = '';
  selectedCatalogDetails: any;
  newStyleId: string = '';
  inValidProductSearch: boolean = false;
  styleIdList: any = [];
  mergeStyleIdList: any = [];
  showMergeModal: boolean = false;
  overwriteDefaultStyleVersion: boolean = false;
  targetVersion: any;
  versionList: any = [];
  selectedStyleIdList: any = [];
  mergeBtn = 'Merge';
  moveBtn = 'Move';
  @Input() resetListDetails: any;
  productList: boolean = false;
  selectedProdctId: string = '';
  selectedProdctVersion: string = '';
  @Input() listOfParentData: any = [];
  @ViewChild(AssociatedProductsComponent) public associatedProductsComponent!: AssociatedProductsComponent;
  constructor(private apiService: ApiService, public authService: AuthService) { }

  ngOnChanges() {

    if (this.resetListDetails && this.resetListDetails.resetList) {
      this.selectedCatalogId = this.resetListDetails.selectedProdctId + this.resetListDetails.selectedVersion
    }
  }


  trackByCatalogId(index: number, catalog: any): number {
    return catalog;  // Or any unique identifier
  }

  onPanelClose(state: boolean, childNode: any, parentList: any, index: number): void {
    this.addIsOpenProperty(parentList[index], false);
    childNode.isOpen = state;
    childNode.hovered = false;
  }


  addIsOpenProperty(node: any, isOpenValue: boolean) {

    node.isOpen = isOpenValue;
    node.hovered = false;

    if (node.subgarments && Array.isArray(node.subgarments)) {
      node.subgarments.forEach((childNode: any) => this.addIsOpenProperty(childNode, isOpenValue));
    }


  }

  preventCollapse(event: Event): void {
    event.stopPropagation();
  }

  toggleCollapse(event: Event): void {
    event.stopPropagation();
  }

  drop(event: CdkDragDrop<any[]>, parentCatalog: any) {
    moveItemInArray(parentCatalog, event.previousIndex, event.currentIndex);
  }

  onChildDrop(event: CdkDragDrop<any[]>, parentCatalog: any) {
    this.drop(event, parentCatalog); // reuse logic
  }

  handleHover(catalog: any, parentList: any, state: boolean) {
    if (state == true) {
      this.addIsMenuOpenProperty(parentList, false);
      catalog['hovered'] = true;

    }
    else {
      if (catalog['isMenuOpen']) {
        catalog['hovered'] = true
      }
      else {
        catalog['hovered'] = false
      }
    }
  }

  loadCatalog(catalog: any) {
    if (catalog?.styleId) {
      this.selectedCatalogId = catalog["styleId"] + catalog["version"];
      this.selectedVersion = catalog["version"];
      this.emitSeqId.emit(catalog);
    }
  }

  openProducts(catalog: any) {
    if (catalog?.styleId && catalog?.totalLinkedProducts > 0) {
      this.productList = true;
      this.selectedProdctId = catalog["styleId"];
      this.selectedProdctVersion = catalog["version"];
    }
  }

  addIsMenuOpenProperty(node: any, isOpenValue: boolean) {
    if (!Array.isArray(node)) {
      node.isMenuOpen = isOpenValue;
      node.hovered = isOpenValue;
    }


    if (node && Array.isArray(node)) {
      node.forEach((childNode: any) => this.addIsMenuOpenProperty(childNode, isOpenValue));
    }

  }

  onConfirm() {
    this.showModal = false;
    if (this.modalButton == 'Delete' || this.modalButton == 'Undelete') {
      this.showModal = false;
      this.emitAction.emit({ action: this.selectedCatalogDetails.deleteInd == 1 ? 'Undelete' : 'Delete', data: this.selectedCatalogDetails })

    }
  }

  deleteCatalog(data: any) {
    if (!this.authService.MCDelete)
      return;

    this.modalWidth = '520px';
    this.showModal = true;
    this.modalButton = data.deleteInd == 1 ? 'Undelete' : 'Delete';
    this.modalMessage = data.deleteInd == 1 ?
      `Are you sure to undelete the selected product? <br> <b>${data.styleId} ---> ${data.version}</b>`
      : `Are you sure to delete the selected product? <br> <b>${data.styleId} ---> ${data.version}</b>`;
    this.selectedCatalogDetails = data;

  }

  moveCatalog(data: any) {
    if (!this.authService.MCAdd)
      return;

    this.newStyleId = '';
    this.versionList = [];
    this.modaltitle = data;
    this.moveBtn = 'Move';
    this.showMovePopup = true;
    this.getStyleIdlist(data);
    this.selectedCatalogDetails = data;

  }

  mergeCatalog(data: any) {
    if (!this.authService.MCAdd)
      return;

    this.showMergeModal = true;
    this.overwriteDefaultStyleVersion = false;
    this.versionList = [];
    this.mergeBtn = 'Merge';
    this.selectedCatalogDetails = data;
    this.getStyleListbyId(data);
  }

  getStyleIdlist(data: any) {
    this.apiService.getStyleIdList().subscribe(response => {
      this.styleIdList = response;
      this.styleIdList = this.styleIdList.filter((res: any) => res != data.styleId);
      this.getStyleListbyId(data, 'move');
    })
  }

  getStyleListbyId(data: any, action?: string) {
    this.apiService.getStyleListById(data.styleId).subscribe(response => {
      this.mergeStyleIdList = response.map((item: any) => ({ ...item, disabled: false }));
      this.selectedStyleIdList = response.map((item: any) => ({ ...item, disabled: false }));

      this.versionList = this.selectedStyleIdList.filter((res: any) => res.version === data.version);

      if (!action) {
        this.targetVersion = this.mergeStyleIdList[0];
        const targetVer = this.targetVersion?.version;

        this.mergeStyleIdList.forEach((res: any) => {
          const isPickedOnLeft = this.versionList.some((v: any) => v.version === res.version);
          res.disabled = isPickedOnLeft;
        });

        this.selectedStyleIdList.forEach((res: any) => {
          res.disabled = res.version === targetVer;
        });
      }
    });
  }

  alterMergeList(list: any) {
    const disableVersionSet = new Set(list.map((item: any) => item.version));

    this.mergeStyleIdList = this.mergeStyleIdList.map((item: any) => ({
      ...item,
      disabled: disableVersionSet.has(item.version)
    }));

    if (this.versionList.length > 1) {
      this.overwriteDefaultStyleVersion = false;
    }
  }

  alterSelectedList(selectedTarget: any) {

    const targetVersionStr = typeof selectedTarget === 'object'
      ? selectedTarget?.version
      : selectedTarget;

    this.selectedStyleIdList.forEach((item: any) => {
      const isCurrentlySelectedOnLeft = this.versionList?.some((v: any) => v.version === item.version);

      if (targetVersionStr && item.version === targetVersionStr && !isCurrentlySelectedOnLeft) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });

    this.selectedStyleIdList = [...this.selectedStyleIdList];
    if (selectedTarget.salsifyIndicator) {
      this.overwriteDefaultStyleVersion = false;
    }
  }

  confirmMoveAction() {
    this.emitAction.emit({ action: 'Move', data: { styleId: this.selectedCatalogDetails.styleId, newStyleId: this.newStyleId, version: this.versionList.map((res: any) => res.version) } })
  }

  confirmMergeAction() {
    const emitData: any = {
      styleId: this.selectedCatalogDetails.styleId,
      overwriteDefaultStyleVersion: this.overwriteDefaultStyleVersion,
      version: (this.versionList || []).map((res: any) => res.version),
      targetVersion: this.targetVersion.version
    };

    this.emitAction.emit({ action: 'Merge', data: emitData });
  }

  copyCatalog(data: any) {
    if (!this.authService.MCAdd)
      return;
    this.emitAction.emit({ action: 'Copy', data: data });

  }

  updateToggle(evt: any) {
    this.isAllExpanded = evt;

  }


}
